export const hasFleetAdminPermission = (roles) => {
    const fleetManagerRoles = ['Fleet Manager', 'dealer_admin', 'Admin', 'AdminMain', 'Account Manager', 'Director'];
    return fleetManagerRoles.some((item) => roles.includes(item));
}